import PropTypes from "prop-types";
import React from "react";
import { Button, Popup } from "semantic-ui-react";

export const MetadataLinkButton = ({ link }) => {
  return (
    <Popup
      content={"See resource metadata"}
      trigger={
        <Button size={"tiny"} as={"a"} href={link} icon="location arrow" />
      }
    />
  );
};

MetadataLinkButton.propTypes = {
  link: PropTypes.string,
};
